// Copyright (c) 2016 Deere & Company

import PartReturns, {getDefaultState as getPartReturnsDefaultState} from '../../shared/state/part-returns';
import actions from '../../actions-list';

const readOpenPartRequests = (state, action) =>
    PartReturns.update(state, {
        $set: action.data
    });

export default (state = getPartReturnsDefaultState(), action) => {

    const actionHandlers = {
        [actions.READ_OPEN_PART_REQUESTS_SUCCESS]: readOpenPartRequests
    };
    const reducer = actionHandlers[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/reducers/part-returns.js